//SingleBlog.js
///////////////////////////////
//React & Material
import React from 'react';
import { Col, Image, Row } from 'react-bootstrap';
import Container from 'react-bootstrap/Container';
import { Helmet } from 'react-helmet';
import { Link } from "react-router-dom";
//Plugins
import styled from 'styled-components';
import DashRound from '../../media/projects/1.Biorific/Admin Dashboard Round.png';
import MainImage from '../../media/projects/1.Biorific/biorific-main.svg';
import SolutionImage from '../../media/projects/1.Biorific/biorific-solution.png';
import PlantRound from '../../media/projects/1.Biorific/Organization Dashboard Round.png';
import GithubLogo from '../../media/projects/github-logo.svg';
import NextArrow from '../../media/projects/next-arrow.svg';
import EndVector from '../../media/projects/projects-end.svg';

//Component Imports

//////////////////////////////
//Styled components
const Wrapper = styled(Container)`
  padding:40px;
`
const CustomRow = styled(Row)`
  margin-top:${props => props.marginTop};
  // padding:30px;
`

const HeaderRow = styled(Row)`
margin-top:${props => props.marginTop};
@media only screen and (max-width: 767px) {
  justify-content:center;
  align-items:center;
}

@media only screen and (max-width: 767px) and (orientation: portrait) {
  justify-content:center;
  align-items:center;
}
`

const SolutionContainer = styled.div`
  margin-top:${props => props.marginTop};
  
`
const ProjectTitle = styled.h1`
  font-size:50px;


  @media only screen and (min-width: 768px) {
    /* tablets and desktop */
    margin-left:5vw;
  }

  @media only screen and (max-width: 767px) {
    font-weight:bold;
    font-size:1.8rem;
  }
  
  @media only screen and (max-width: 767px) and (orientation: portrait) {
    font-weight:bold;
    font-size:1.8rem;
  }
`

const SubTopic = styled.h2`
@media only screen and (max-width: 767px) {

  font-size:1.2rem;
  max-width:70%;
}

@media only screen and (max-width: 767px) and (orientation: portrait) {

  font-size:1.2rem;
  max-width:70%;
}

`
const G = styled.span`
  color:#36FFC1;
`

const OverviewRow = styled(Row)`
margin-top:5vh;
align-items:flex-end;
justify-content:flex-end;
flex-direction: column;
@media only screen and (max-width: 767px) {
  justify-content:center;
  align-items:center;
  
}

@media only screen and (max-width: 767px) and (orientation: portrait) {
  justify-content:center;
  align-items:center;
  
}
`
const SubOverview = styled(Row)`
align-items:flex-start;
justify-content:flex-start;
flex-direction: column;
@media only screen and (max-width: 767px) {
  justify-content:center;
  align-items:center;
  
}

@media only screen and (max-width: 767px) and (orientation: portrait) {
  justify-content:center;
  align-items:center;
  
}
`
const RoleOverview = styled(Row)`
align-items:flex-start;
justify-content:flex-start;
flex-direction: row;
text-align: left;
margin-top:2vh;

@media only screen and (max-width: 767px) {
  justify-content:center;
  align-items:center;
  text-align: center;
}

@media only screen and (max-width: 767px) and (orientation: portrait) {
  justify-content:center;
  align-items:center;
  text-align: center;
`

const RoleCol = styled(Col)`
// text-align: left;
margin-right:5vw;
`
const SubHeading = styled.h3`
color: rgba(255, 255, 255, 0.35);
margin-bottom:1vh;

media only screen and (max-width: 767px) {

  font-size:1.3rem;
  
}

@media only screen and (max-width: 767px) and (orientation: portrait) {

  font-size:1.3rem;
}

&:hover{
  color:white;
}
`
const SubText = styled.h4`
color: rgba(255, 255, 255, 0.35);
margin-bottom:1vh;


&:hover{
  color:white;
}
`
const TextOverlay = styled.h3`
media only screen and (max-width: 767px) {
  display:inline-block;
  font-size:1.4rem;
  
}

@media only screen and (max-width: 767px) and (orientation: portrait) {
  display:inline-block;
  font-size:1.4rem;
}


`

const SubTextStack = styled.p`
color: rgba(255, 255, 255, 0.35);
margin-bottom:1vh;
&:hover{
  color:white;
}
`
const CustomCol = styled(Col)`
justify-content:flex-end;
text-align:left;
// margin-left:3vw;
align-self: flex-end;

media only screen and (max-width: 767px) {
  margin-top:20px;
  
}

@media only screen and (max-width: 767px) and (orientation: portrait) {
  margin-top:20px;
}

`

const JustifiedText = styled.h5`
text-align:justify;
line-height:145%;
`

const QuestionText = styled.h1`
color: rgba(255, 255, 255, 0.35);
// margin-bottom:1vh;
transition: color 1s ease-out;
&:hover{
  color:white;
}
`

const QuestionMark = styled.h1`
font-size:10em;
font-style:italic;
color: rgba(255, 255, 255, 0.35);
`

const QuestionF = styled(Row)`
justify-content:center;
align-items:center
`
const QuestionM = styled(Row)`
justify-content:center;
margin-bottom: -2vh;
`
const QuestionLast = styled(Row)`
justify-content:flex-end;
margin-right:7vw;
`

const Solution = styled(Image)`
// height:1000px;
// padding:40px;
max-width: 100%;
height: auto;
// width: 100%;
// height: auto;
`

const EndImages = styled(Image)`
  height:500px;
`

const BackgroundContainer = styled(Container)`
  background: url(${EndVector});
  background-size: contain;
  background-repeat: no-repeat;

`

const SmallRow = styled(Row)`
  width:500px;
  text-align:left;
  margin-top:2vh;
`



const EndText = styled.h2`
font-weight: bold;
color:${props => props.color};
text-align:left;
`
const GitRow = styled.div`
  display:flex;
  justify-content:flex-start;
  align-content:center;
  flex-direction:row;
`

const GitCol = styled.div`
  display:flex;
  justify-content:center;
  align-content:center;
  margin-right:20px;
`
const CodebaseText = styled.h3`
color: rgba(255, 255, 255, 0.35);
margin-bottom:0;
&:hover{
  color:white;
}
`

const EndContainer = styled(Container)`
  width:30vw;
`


const Arrow = styled.span`

`

const GoBackSection = styled(Link)`
  display:flex;
  align-items:center;
  justify-content:center;
  margin-bottom:3vh;
  &:focus, &:hover, &:visited, &:link, &:active {
    text-decoration: none;
  }
`

const BackArrow = styled(Image)`
margin-right:10px;
`

const BackText = styled.h2`
font-weight: bold;
line-height: 35px;
font-size:1.5em;
color:${props => props.color};
`

const CustomLink = styled.div`
text-decoration: none;
-webkit-transition: color 1s ease-out;
-moz-transition: color 1s ease-out;
-o-transition: color 1s ease-out;
-ms-transition: color 1s ease-out;
transition: color 1s ease-out;
    &:focus, &:visited, &:link, &:active {
        text-decoration: none;
        color:inherit;
    }
    &:hover{
      text-decoration: none;
      color:#36FFC1;
    }
    
`
//////////////////////////////
//Component class
/**
 * Displays a template component
 */
function SingleBlog(props) {

  var x = 30;



  const TextHeading = (marginTop, title, content) => {
    return (
      <CustomRow marginTop={marginTop}>
        <Row>
          <SubHeading>
            {title}<G>.</G>
          </SubHeading>
        </Row>
        <Row>
          <JustifiedText>
            {content}
          </JustifiedText>
        </Row>
      </CustomRow>
    )
  }

 
 

  return (

    
    <Wrapper>
      {/* Document Title Section  */}
      <Helmet>
        <title>Build something cool | Blog | GayuruG</title>
      </Helmet>

      <HeaderRow marginTop="4vh"> 
      <ProjectTitle>
        Build something cool<G>.</G>
      </ProjectTitle>
      </HeaderRow>
      <OverviewRow>
        <SubOverview>
          <SubTopic>
          The Most Important Skill Nobody Taught You<G>.</G>
          </SubTopic>
          <RoleOverview>
            <RoleCol>
              <h3>
                <SubHeading>
                  Read time <br />
                </SubHeading>
                <TextOverlay>2 min<G>.</G></TextOverlay>
              </h3>
            </RoleCol>
            <RoleCol>
              <h3>
                <SubHeading>
                  Date <br />
                </SubHeading>
                <TextOverlay>Mar 2020<G>.</G></TextOverlay>
              </h3>
            </RoleCol>
          </RoleOverview>
        </SubOverview>
      </OverviewRow>

      {/* Introduction Section */}
      <CustomRow marginTop="8vh">
        <Col sm={7}>
          <Image fluid src={MainImage} />
        </Col>
        <CustomCol sm={5}>
          <Row>
            <h3>
              Biorific is a solution to remote plant monitoring for everyone. <br /><br />
              <SubText>
                Capture how your plant's surroundings are tracking, including the moisture in the soil, the amount of light your plant is getting and the temperature of its environment from anywhere in the world.
          </SubText>
            </h3>
          </Row>
        </CustomCol>
      </CustomRow>

      {/* Challenge Section */}
      {TextHeading("10vh", "The Perils of Being Connected", "Nearly 5 million patients each month use ZocDoc products to find in-network doctors. While the average national wait time to see a doctor is nearly three weeks, the majority of ZocDoc appointments take place within 24 – 72 hours. I designed a solution that can help verify the doctor’s current status with the medical insurance carrier. This would be an additional step to verify that the doctor is indeed in-network and would accept the patient's medical plan.")}

      {/* Question Section */}
      <CustomRow marginTop="8vh">
          <QuestionF noGutters>
            <QuestionText><G>“</G> All of humanity’s problems stem from man’s inability to sit quietly in a room alone <G>”</G></QuestionText>
          </QuestionF>
      </CustomRow>

      {/* Solution Section */}
      {TextHeading("5vh", "The solution", "I designed a solution that can help verify the doctor’s current status with the medical insurance carrier. This would be an additional step to verify that the doctor is indeed in-network and would accept the patient's medical plan.")}

      {/* Project Solution */}
      <SolutionContainer marginTop="8vh">
        <Solution fluid src={SolutionImage} />
      </SolutionContainer>


      {/* The End Vectors */}
      <CustomRow marginTop="8vh">
        <BackgroundContainer>
          <RoleOverview>
            <EndImages fluid src={DashRound} />
          </RoleOverview>
          <OverviewRow>
            <EndImages fluid src={PlantRound} />
          </OverviewRow>
        </BackgroundContainer>
      </CustomRow>


      {/* The Conclusion */}
      <CustomRow marginTop="10vh">
        <Container>
          <Row>
            <h3>Blazing fast and easily scalable<G>.</G></h3>
          </Row>
          <SmallRow>
            <SubText>
              Capture how your plant's surroundings are tracking, including the moisture in the soil, the amount of light your plant is getting and the temperature of its environment from anywhere in the world.
          </SubText>
          </SmallRow>
        </Container>
      </CustomRow>

    


      {/* The End */}
      <CustomRow marginTop="8vh">
        <EndContainer>
          <GitRow>
            <GitCol>
              <Image src={GithubLogo} />
            </GitCol>
            <GitCol>
              <EndText>
                share
                <CodebaseText>
                  this article
                </CodebaseText>
              </EndText>
            </GitCol>
          </GitRow>
          <OverviewRow>
            <EndText color="#36FFC1">
              Munchys <Arrow><Image src={NextArrow} fluid /></Arrow><br />
              <SubHeading>
                next blog
            </SubHeading>
            </EndText>
          </OverviewRow>
        </EndContainer>
      </CustomRow>

    </Wrapper>
  )
}
export default SingleBlog;